/**
 * DECOY BROWSER MODULE
 * Injects a dual-pane browser into #CONTENT_CONTAINER
 * Handles Desktop (Side-by-side with video reveal) and Mobile (Portrait overlay) modes.
 */

(function () {
    // --- 1. CONFIG & HELPERS ---

    VOD_SVG = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
     viewBox="0 0 1000 1000" style="enable-background:new 0 0 1000 1000;" xml:space="preserve">
<style type="text/css">
    .st0{transition:fill 0.35s cubic-bezier(0, 0.54, 0, 1), stroke 0.35s cubic-bezier(0, 0.54, 0, 1); fill:var(--MainValue);}
    .st1{transition:fill 0.35s cubic-bezier(0, 0.54, 0, 1), stroke 0.35s cubic-bezier(0, 0.54, 0, 1); fill:var(--AntiValue);stroke:var(--AntiValue);stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
    .st2{transition:fill 0.35s cubic-bezier(0, 0.54, 0, 1), stroke 0.35s cubic-bezier(0, 0.54, 0, 1);fill:none;stroke:var(--AntiValue);stroke-miterlimit:10;}
    .st3{transition:fill 0.35s cubic-bezier(0, 0.54, 0, 1), stroke 0.35s cubic-bezier(0, 0.54, 0, 1);fill:var(--Highlight);}
    .st4{transition:fill 0.35s cubic-bezier(0, 0.54, 0, 1), stroke 0.35s cubic-bezier(0, 0.54, 0, 1);fill:var(--AntiValue);}
    .st5{transition:fill 0.35s cubic-bezier(0, 0.54, 0, 1), stroke 0.35s cubic-bezier(0, 0.54, 0, 1);fill:none;stroke:var(--AntiValue);stroke-linecap:round;stroke-miterlimit:10;}
</style>
<g id="Layer_17">
    <path class="st0" d="M323.6666565,1020.111084l-67.9999847-134.666626l-5.7026367-42.3440552L386.777771,706.333313L425,865.444458
        c0,0,84.444458,19.555542,84.8888855,22.222229c0.444458,2.666626,8.0000305,120.888855,8.0000305,120.888855l-176.888916,4
        L323.6666565,1020.111084z"/>
    <polygon class="st0" points="133.6666718,856.111084 124.9596252,843.0487671 383.9264526,584.333313 374.7602234,687.0473022 
        209,852.666687  "/>
    <polygon class="st0" points="624.9824829,600 950,600 950,874.381897 890,874.75 894.0366211,1024 575,1020.111084 
        593.7391968,608.7202759     "/>
</g>
<g id="Layer_19">
    <path style="display:none" class="st1" d="M950,700c0,0,0-100-100-100c0,0,100,0,100-100V700z"/>
    <path class="st1 starRotator" d="M949.999939,549.999939c0,50.000061-50,50.000061-50,50.000061c50,0,50,50,50,50
    c0-50,50.000061-50,50.000061-50C949.999939,600,949.999939,549.999939,949.999939,549.999939z"/>
</g>
<g id="Layer_18">
    <polyline class="st2" points="624.9824829,600 950,600 950,769   "/>
</g>
<g id="Layer_13">
    <path class="st3" d="M437.4498596,843.1004028V718.0731812l62.5136108-62.5135498
        c-34.5252991,0-62.5136108-27.9882813-62.5136108-62.5136108s27.9883118-62.5136108,62.5136108-62.5136108
        s62.5135803,27.9882813,62.5135803,62.5136108c0,11.387207-3.0460815,22.0623779-8.3657837,31.2576904
        c5.2376709,9.1434326,8.3657837,19.9638062,8.3657837,31.2559204c0,34.5253296-27.9882813,62.5135498-62.5135803,62.5135498
        h62.5135803v125.0272217h62.5136108V780.586792V593.0460205c0-69.0505981-55.9765625-125.0272217-125.0271912-125.0272217
        s-125.0272217,55.9766235-125.0272217,125.0272217V780.586792v62.5136108H437.4498596z"/>
</g>
<g id="Layer_15">
</g>
<g id="Layer_12">
    <path class="st4" d="M0.0000001,905.6633301l62.4861145-62.5629272V999.354126H0.0000001V905.6633301z M0.0000001,843.1004028
        h31.2051315L0.0000001,874.381897V843.1004028z"/>
    <path class="st4" d="M93.6985855,874.381897l31.2051315-31.2814941h93.7670898v31.2814941h-31.2809753l-62.4861145,62.4855957
        H93.6985855V874.381897z M93.6985855,968.1489868h31.2051315l31.2809753-31.2814941h62.4861145v31.2814941l-31.2809753,31.2051392
        h-93.691246V968.1489868z"/>
    <path class="st4" d="M249.964035,968.1489868v-125.048584l62.4860992,62.5629272v31.2041626h31.2051392V874.381897h-31.2051392
        l-31.2809753-31.2814941h93.7670898V999.354126h-93.7670898L249.964035,968.1489868z"/>
    <path class="st3" d="M499.9212036,905.6633301h-93.6912231v-62.5629272h124.9727173V999.354126h-31.2814941V905.6633301z"/>
    <path class="st4" d="M656.1866455,843.1004028h31.2814941v62.5629272l-31.2814941,31.2041626V843.1004028z"/>
    <path class="st4" d="M718.7613525,874.381897l31.2051392-31.2814941h31.2814331V999.354126h-62.4865723V874.381897z
         M812.4520874,843.1004028l31.2814941,31.2814941v31.2814331l-31.2814941,31.2041626V843.1004028z"/>
    <path class="st4" d="M875.027771,843.1004028H1000v31.2814941l-31.2814941,31.2814331h-62.4855957l31.2814941,31.2041626H1000
        l-31.2814941,31.2814941L1000,999.354126H875.027771V843.1004028z"/>
    <path class="st4" d="M-0.037926,590.7202759h31.2430573v31.281189H15.5645285v46.84552H-0.037926V590.7202759z
         M31.2051315,637.6039429h15.6024551v-46.883667h15.6406021v78.126709H31.2051315V637.6039429z"/>
    <path class="st4" d="M0.0000001,668.8469849h62.4861145v15.640625l-15.6406021,15.640564H15.6024551l15.6406021,15.602478
        h31.2430573l-15.6406021,15.640564l15.6406021,15.602478H0.0000001V668.8469849z"/>
    <path class="st4" d="M0.0000001,746.9736938h15.6024551v15.640625H0.0000001V746.9736938z M0.0000001,778.2548828h15.6024551
        l15.6406021-15.640564l15.6024551,15.640564h15.6406021v46.84552H46.8455124l-15.6024551-15.602417l-15.6406021,15.602417
        H0.0000001V778.2548828z M46.8455124,746.9736938h15.6406021v15.640625H46.8455124V746.9736938z"/>
    <g>
        <path class="st4" d="M640.6044922,811.8330078h-15.6142578v-46.9199219h15.6142578l15.6533203,15.6523438l15.6142578-15.6523438
            h15.6533203v46.9199219h-15.6533203l-15.6142578,15.6533203L640.6044922,811.8330078z M624.9902344,827.4863281h15.6142578
            v15.6142578h-15.6142578V827.4863281z M671.8720703,827.4863281h15.6533203v15.6142578h-15.6533203V827.4863281z"/>
        <path class="st4" d="M703.1875,827.4863281v-62.5732422l31.2675781,31.3056641v15.6142578h15.6142578v-31.2675781h-15.6142578
            l-15.6533203-15.6523438h46.9208984v78.1875h-46.9208984L703.1875,827.4863281z"/>
        <path class="st4" d="M781.3847656,764.9130859h46.8818359l15.6533203,15.6523438v31.2675781h-31.2675781l31.2675781,31.2675781
            h-62.5351563V764.9130859z"/>
        <path class="st4" d="M859.5820313,780.5654297l15.6142578-15.6523438h15.6533203v78.1875h-31.2675781V780.5654297z
             M906.4638672,764.9130859l15.6533203,15.6523438V796.21875l-15.6533203,15.6142578V764.9130859z"/>
        <path class="st4" d="M937.7792969,764.9130859h31.2675781V796.21875h31.2675781v15.6142578H969.046875v31.2675781h-31.2675781
            V764.9130859z M984.6611328,764.9130859h15.6533203v15.6523438h-15.6533203V764.9130859z M984.6611328,827.4863281h15.6533203
            v15.6142578h-15.6533203V827.4863281z"/>
    </g>
    <path class="st4" d="M654.6005859,631.8313599c2.7441406-2.7451172,6.0263672-4.1191406,9.84375-4.1191406
        c3.8164063,0,7.0976563,1.3740234,9.8447266,4.1191406c2.7451172,2.7470703,4.1191406,6.0283203,4.1191406,9.8447266
        c0,0.7460938-0.2792969,1.3964844-0.8378906,1.9550781s-1.2109375,0.8378906-1.9541016,0.8378906
        c-0.7460938,0-1.3964844-0.2792969-1.9550781-0.8378906s-0.8378906-1.2089844-0.8378906-1.9550781
        c0-2.3261719-0.8164063-4.3046875-2.4433594-5.9345703c-1.6298828-1.6279297-3.609375-2.4443359-5.9355469-2.4443359
        c-2.3271484,0-4.3066406,0.8164063-5.9345703,2.4443359c-1.6298828,1.6298828-2.4433594,3.6083984-2.4433594,5.9345703v22.3417969
        c0,2.328125,0.8134766,4.3066406,2.4433594,5.9345703c1.6279297,1.6298828,3.6074219,2.4433594,5.9345703,2.4433594
        c2.3261719,0,4.3056641-0.8134766,5.9355469-2.4433594c1.6269531-1.6279297,2.4433594-3.6064453,2.4433594-5.9345703
        c0-0.7441406,0.2792969-1.3964844,0.8378906-1.9550781s1.2089844-0.8378906,1.9550781-0.8378906
        c0.7431641,0,1.3955078,0.2792969,1.9541016,0.8378906s0.8378906,1.2109375,0.8378906,1.9550781
        c0,3.8183594-1.3740234,7.0996094-4.1191406,9.8447266c-2.7470703,2.7470703-6.0283203,4.1191406-9.8447266,4.1191406
        c-3.8173828,0-7.0996094-1.3720703-9.84375-4.1191406c-2.7470703-2.7451172-4.1191406-6.0263672-4.1191406-9.8447266v-22.3417969
        C650.4814453,637.8596802,651.8535156,634.5784302,654.6005859,631.8313599z"/>
    <path class="st4" d="M695.1650391,672.395813h19.5498047c0.7431641,0,1.3955078,0.2792969,1.9541016,0.8378906
        s0.8378906,1.2109375,0.8378906,1.9550781c0,0.7460938-0.2792969,1.3964844-0.8378906,1.9550781
        s-1.2109375,0.8378906-1.9541016,0.8378906h-22.3427734c-0.7460938,0-1.3964844-0.2792969-1.9550781-0.8378906
        c-0.5576172-0.5585938-0.8369141-1.2089844-0.8369141-1.9550781V630.505188c0-0.7441406,0.2792969-1.3964844,0.8369141-1.9550781
        c0.5585938-0.5585938,1.2089844-0.8378906,1.9550781-0.8378906c0.7441406,0,1.3964844,0.2792969,1.9550781,0.8378906
        s0.8378906,1.2109375,0.8378906,1.9550781V672.395813z"/>
    <path class="st4" d="M731.4707031,627.7122192h11.1708984h11.171875c0.7431641,0,1.3955078,0.2792969,1.9541016,0.8378906
        s0.8378906,1.2109375,0.8378906,1.9550781c0,0.7460938-0.2792969,1.3964844-0.8378906,1.9550781
        s-1.2109375,0.8369141-1.9541016,0.8369141h-8.3789063v39.0986328h8.3789063c0.7431641,0,1.3955078,0.2792969,1.9541016,0.8378906
        s0.8378906,1.2109375,0.8378906,1.9550781c0,0.7460938-0.2792969,1.3964844-0.8378906,1.9550781
        s-1.2109375,0.8378906-1.9541016,0.8378906h-11.171875h-11.1708984c-0.7460938,0-1.3964844-0.2792969-1.9550781-0.8378906
        c-0.5576172-0.5585938-0.8369141-1.2089844-0.8369141-1.9550781c0-0.7441406,0.2792969-1.3964844,0.8369141-1.9550781
        c0.5585938-0.5585938,1.2089844-0.8378906,1.9550781-0.8378906h8.3789063v-39.0986328h-8.3789063
        c-0.7460938,0-1.3964844-0.2783203-1.9550781-0.8369141c-0.5576172-0.5585938-0.8369141-1.2089844-0.8369141-1.9550781
        c0-0.7441406,0.2792969-1.3964844,0.8369141-1.9550781C730.0742188,627.9915161,730.7246094,627.7122192,731.4707031,627.7122192z"
        />
    <path class="st4" d="M771.8964844,631.8313599c2.7441406-2.7451172,6.0263672-4.1191406,9.84375-4.1191406
        c3.8164063,0,7.0976563,1.3740234,9.8447266,4.1191406c2.7451172,2.7470703,4.1191406,6.0283203,4.1191406,9.8447266
        c0,0.7460938-0.2792969,1.3964844-0.8378906,1.9550781s-1.2109375,0.8378906-1.9541016,0.8378906
        c-0.7460938,0-1.3964844-0.2792969-1.9550781-0.8378906s-0.8378906-1.2089844-0.8378906-1.9550781
        c0-2.3261719-0.8164063-4.3046875-2.4433594-5.9345703c-1.6298828-1.6279297-3.609375-2.4443359-5.9355469-2.4443359
        c-2.3271484,0-4.3066406,0.8164063-5.9345703,2.4443359c-1.6298828,1.6298828-2.4433594,3.6083984-2.4433594,5.9345703v22.3417969
        c0,2.328125,0.8134766,4.3066406,2.4433594,5.9345703c1.6279297,1.6298828,3.6074219,2.4433594,5.9345703,2.4433594
        c2.3261719,0,4.3056641-0.8134766,5.9355469-2.4433594c1.6269531-1.6279297,2.4433594-3.6064453,2.4433594-5.9345703
        c0-0.7441406,0.2792969-1.3964844,0.8378906-1.9550781s1.2089844-0.8378906,1.9550781-0.8378906
        c0.7431641,0,1.3955078,0.2792969,1.9541016,0.8378906s0.8378906,1.2109375,0.8378906,1.9550781
        c0,3.8183594-1.3740234,7.0996094-4.1191406,9.8447266c-2.7470703,2.7470703-6.0283203,4.1191406-9.8447266,4.1191406
        c-3.8173828,0-7.0996094-1.3720703-9.84375-4.1191406c-2.7470703-2.7451172-4.1191406-6.0263672-4.1191406-9.8447266v-22.3417969
        C767.7773438,637.8596802,769.1494141,634.5784302,771.8964844,631.8313599z"/>
    <path class="st4" d="M813.578125,652.8469849l20.3867188,20.3867188c0.5585938,0.5585938,0.8378906,1.2109375,0.8378906,1.9550781
        c0,1.2109375-0.5820313,2.0732422-1.7451172,2.5839844c-1.1650391,0.5097656-2.1640625,0.3007813-3.0019531-0.6289063
        l-17.5947266-17.5947266v15.6396484c0,0.7460938-0.2792969,1.3964844-0.8378906,1.9550781
        s-1.2109375,0.8378906-1.9550781,0.8378906c-0.7460938,0-1.3964844-0.2792969-1.9550781-0.8378906
        c-0.5576172-0.5585938-0.8369141-1.2089844-0.8369141-1.9550781V630.505188c0-0.7441406,0.2792969-1.3964844,0.8369141-1.9550781
        c0.5585938-0.5585938,1.2089844-0.8378906,1.9550781-0.8378906c0.7441406,0,1.3964844,0.2792969,1.9550781,0.8378906
        s0.8378906,1.2109375,0.8378906,1.9550781v15.6386719l17.5947266-17.59375
        c0.5585938-0.5585938,1.2089844-0.8378906,1.9550781-0.8378906c1.2080078,0,2.0703125,0.5820313,2.5830078,1.7451172
        c0.5107422,1.1650391,0.3007813,2.1650391-0.6289063,3.0029297L813.578125,652.8469849z"/>
    <path class="st4" d="M863.5683594,662.6487427c0.5585938-0.5585938,1.2089844-0.8378906,1.9550781-0.8378906
        c1.2089844,0,2.0703125,0.5820313,2.5830078,1.7451172c0.5107422,1.1650391,0.3017578,2.1650391-0.6279297,3.0029297
        l-11.1708984,11.1708984c-0.5585938,0.5585938-1.2109375,0.8378906-1.9550781,0.8378906
        c-1.2109375,0-2.0732422-0.5830078-2.5830078-1.7460938c-0.5126953-1.1650391-0.3037109-2.1640625,0.6279297-3.0019531
        L863.5683594,662.6487427z"/>
    <path class="st4" d="M662.4902344,724.8997192c0.5585938-0.5585938,1.2080078-0.8378906,1.9541016-0.8378906h0.1396484
        c0.2792969,0,0.5810547,0.0703125,0.9082031,0.2099609c0.3251953,0.1396484,0.6279297,0.3486328,0.9072266,0.6279297
        l6.4238281,6.4238281v-37.9814453c0-0.7441406,0.2792969-1.3964844,0.8378906-1.9550781s1.2089844-0.8378906,1.9550781-0.8378906
        c0.7431641,0,1.3955078,0.2792969,1.9541016,0.8378906s0.8378906,1.2109375,0.8378906,1.9550781v44.6835938
        c0,0.7460938-0.2792969,1.3964844-0.8378906,1.9550781c-0.4667969,0.5585938-1.1162109,0.8378906-1.9541016,0.8378906h-0.1396484
        c-0.6523438,0-1.2568359-0.2792969-1.8154297-0.8378906l-9.2167969-9.2158203l-9.2158203,9.2158203
        c-0.5585938,0.5585938-1.2109375,0.8378906-1.9550781,0.8378906c-0.7460938,0-1.3964844-0.2792969-1.9550781-0.8378906
        c-0.5576172-0.4648438-0.8369141-1.1171875-0.8369141-1.9550781v-44.6835938c0-0.7441406,0.2792969-1.3964844,0.8369141-1.9550781
        c0.5585938-0.5585938,1.2089844-0.8378906,1.9550781-0.8378906c0.7441406,0,1.3964844,0.2792969,1.9550781,0.8378906
        s0.8378906,1.2109375,0.8378906,1.9550781v37.9814453L662.4902344,724.8997192z"/>
    <path class="st4" d="M692.3720703,690.5491333h11.1708984h11.171875c0.7431641,0,1.3955078,0.2792969,1.9541016,0.8378906
        s0.8378906,1.2109375,0.8378906,1.9550781c0,0.7460938-0.2792969,1.3964844-0.8378906,1.9550781
        s-1.2109375,0.8369141-1.9541016,0.8369141h-8.3789063v39.0986328h8.3789063c0.7431641,0,1.3955078,0.2792969,1.9541016,0.8378906
        s0.8378906,1.2109375,0.8378906,1.9550781c0,0.7460938-0.2792969,1.3964844-0.8378906,1.9550781
        s-1.2109375,0.8378906-1.9541016,0.8378906h-11.171875h-11.1708984c-0.7460938,0-1.3964844-0.2792969-1.9550781-0.8378906
        c-0.5576172-0.5585938-0.8369141-1.2089844-0.8369141-1.9550781c0-0.7441406,0.2792969-1.3964844,0.8369141-1.9550781
        c0.5585938-0.5585938,1.2089844-0.8378906,1.9550781-0.8378906h8.3789063v-39.0986328h-8.3789063
        c-0.7460938,0-1.3964844-0.2783203-1.9550781-0.8369141c-0.5576172-0.5585938-0.8369141-1.2089844-0.8369141-1.9550781
        c0-0.7441406,0.2792969-1.3964844,0.8369141-1.9550781C690.9755859,690.8284302,691.6259766,690.5491333,692.3720703,690.5491333z"
        />
    <path class="st4" d="M731.4707031,690.5491333h11.1708984h11.171875c0.7431641,0,1.3955078,0.2792969,1.9541016,0.8378906
        s0.8378906,1.2109375,0.8378906,1.9550781c0,0.7460938-0.2792969,1.3964844-0.8378906,1.9550781
        s-1.2109375,0.8369141-1.9541016,0.8369141h-8.3789063v41.8916016c0,0.7460938-0.2792969,1.3964844-0.8378906,1.9550781
        s-1.2109375,0.8378906-1.9550781,0.8378906c-0.7460938,0-1.3955078-0.2792969-1.9541016-0.8378906
        s-0.8378906-1.2089844-0.8378906-1.9550781v-41.8916016h-8.3789063c-0.7460938,0-1.3964844-0.2783203-1.9550781-0.8369141
        c-0.5576172-0.5585938-0.8369141-1.2089844-0.8369141-1.9550781c0-0.7441406,0.2792969-1.3964844,0.8369141-1.9550781
        C730.0742188,690.8284302,730.7246094,690.5491333,731.4707031,690.5491333z"/>
    <path class="st4" d="M795.7041016,738.0256958c0,0.8378906-0.3271484,1.5361328-0.9775391,2.0947266
        c-0.5576172,0.4667969-1.1650391,0.6982422-1.8144531,0.6982422c-0.2792969,0-0.5126953-0.0458984-0.6982422-0.1396484
        c-0.8378906-0.1855469-1.4443359-0.6503906-1.8154297-1.3964844l-17.0361328-34.0712891v32.8144531
        c0,0.7460938-0.2792969,1.3964844-0.8378906,1.9550781s-1.2109375,0.8378906-1.9550781,0.8378906
        c-0.7460938,0-1.3964844-0.2792969-1.9550781-0.8378906c-0.5576172-0.5585938-0.8369141-1.2089844-0.8369141-1.9550781v-44.6835938
        c0-0.8378906,0.3242188-1.5361328,0.9765625-2.0947266c0.5585938-0.4648438,1.1630859-0.6982422,1.8154297-0.6982422
        c0.2792969,0,0.5107422,0.0478516,0.6982422,0.1396484c0.8378906,0.1875,1.4423828,0.6523438,1.8154297,1.3964844
        l17.0361328,34.0712891v-32.8144531c0-0.7441406,0.2792969-1.3964844,0.8378906-1.9550781s1.2089844-0.8378906,1.9550781-0.8378906
        c0.7431641,0,1.3955078,0.2792969,1.9541016,0.8378906s0.8378906,1.2109375,0.8378906,1.9550781V738.0256958z"/>
    <path class="st4" d="M809.6679688,740.8186646c-0.7460938,0-1.3964844-0.2792969-1.9550781-0.8378906
        c-0.5576172-0.5585938-0.8369141-1.2089844-0.8369141-1.9550781v-44.6835938c0-0.7441406,0.2792969-1.3964844,0.8369141-1.9550781
        c0.5585938-0.5585938,1.2089844-0.8378906,1.9550781-0.8378906h22.3427734c0.7431641,0,1.3955078,0.2792969,1.9541016,0.8378906
        s0.8378906,1.2109375,0.8378906,1.9550781c0,0.7460938-0.2792969,1.3964844-0.8378906,1.9550781
        s-1.2109375,0.8369141-1.9541016,0.8369141h-19.5498047v16.7568359h13.9638672
        c0.7441406,0,1.3964844,0.2792969,1.9550781,0.8378906s0.8378906,1.2109375,0.8378906,1.9550781
        c0,0.7460938-0.2792969,1.3964844-0.8378906,1.9550781s-1.2109375,0.8378906-1.9550781,0.8378906h-13.9638672v16.7558594
        h19.5498047c0.7431641,0,1.3955078,0.2792969,1.9541016,0.8378906s0.8378906,1.2109375,0.8378906,1.9550781
        c0,0.7460938-0.2792969,1.3964844-0.8378906,1.9550781s-1.2109375,0.8378906-1.9541016,0.8378906H809.6679688z"/>
    <path class="st4" d="M850.09375,694.6682739c2.7441406-2.7451172,6.0263672-4.1191406,9.84375-4.1191406
        c3.8164063,0,7.0976563,1.3740234,9.8447266,4.1191406c2.7451172,2.7470703,4.1191406,6.0283203,4.1191406,9.8447266
        c0,0.7460938-0.2792969,1.3964844-0.8378906,1.9550781s-1.2109375,0.8378906-1.9541016,0.8378906
        c-0.7460938,0-1.3964844-0.2792969-1.9550781-0.8378906s-0.8378906-1.2089844-0.8378906-1.9550781
        c0-2.3261719-0.8164063-4.3046875-2.4433594-5.9345703c-1.6298828-1.6279297-3.609375-2.4443359-5.9355469-2.4443359
        c-2.3271484,0-4.3066406,0.8164063-5.9345703,2.4443359c-1.6298828,1.6298828-2.4433594,3.6083984-2.4433594,5.9345703
        c0,2.328125,0.8134766,4.3066406,2.4433594,5.9345703c1.6279297,1.6298828,3.6074219,2.4433594,5.9345703,2.4433594
        c3.8164063,0,7.0976563,1.375,9.8447266,4.1191406c2.7451172,2.7470703,4.1191406,6.0283203,4.1191406,9.8447266
        c0,3.8183594-1.3740234,7.0996094-4.1191406,9.8447266c-2.7470703,2.7470703-6.0283203,4.1191406-9.8447266,4.1191406
        c-3.8173828,0-7.0996094-1.3720703-9.84375-4.1191406c-2.7470703-2.7451172-4.1191406-6.0263672-4.1191406-9.8447266
        c0-0.7441406,0.2792969-1.3964844,0.8369141-1.9550781c0.5585938-0.5585938,1.2089844-0.8378906,1.9550781-0.8378906
        c0.7441406,0,1.3964844,0.2792969,1.9550781,0.8378906s0.8378906,1.2109375,0.8378906,1.9550781
        c0,2.328125,0.8134766,4.3066406,2.4433594,5.9345703c1.6279297,1.6298828,3.6074219,2.4433594,5.9345703,2.4433594
        c2.3261719,0,4.3056641-0.8134766,5.9355469-2.4433594c1.6269531-1.6279297,2.4433594-3.6064453,2.4433594-5.9345703
        c0-2.3261719-0.8164063-4.3046875-2.4433594-5.9345703c-1.6298828-1.6279297-3.609375-2.4433594-5.9355469-2.4433594
        c-3.8173828,0-7.0996094-1.3730469-9.84375-4.1191406c-2.7470703-2.7451172-4.1191406-6.0263672-4.1191406-9.8447266
        C845.9746094,700.6965942,847.3466797,697.4153442,850.09375,694.6682739z"/>
    <path class="st4" d="M889.1923828,694.6682739c2.7441406-2.7451172,6.0263672-4.1191406,9.84375-4.1191406
        c3.8164063,0,7.0976563,1.3740234,9.8447266,4.1191406C911.6259766,697.4153442,913,700.6965942,913,704.5130005
        c0,0.7460938-0.2792969,1.3964844-0.8378906,1.9550781s-1.2109375,0.8378906-1.9541016,0.8378906
        c-0.7460938,0-1.3964844-0.2792969-1.9550781-0.8378906s-0.8378906-1.2089844-0.8378906-1.9550781
        c0-2.3261719-0.8164063-4.3046875-2.4433594-5.9345703c-1.6298828-1.6279297-3.609375-2.4443359-5.9355469-2.4443359
        c-2.3271484,0-4.3066406,0.8164063-5.9345703,2.4443359c-1.6298828,1.6298828-2.4433594,3.6083984-2.4433594,5.9345703
        c0,2.328125,0.8134766,4.3066406,2.4433594,5.9345703c1.6279297,1.6298828,3.6074219,2.4433594,5.9345703,2.4433594
        c3.8164063,0,7.0976563,1.375,9.8447266,4.1191406C911.6259766,719.7571411,913,723.0383911,913,726.8547974
        c0,3.8183594-1.3740234,7.0996094-4.1191406,9.8447266c-2.7470703,2.7470703-6.0283203,4.1191406-9.8447266,4.1191406
        c-3.8173828,0-7.0996094-1.3720703-9.84375-4.1191406c-2.7470703-2.7451172-4.1191406-6.0263672-4.1191406-9.8447266
        c0-0.7441406,0.2792969-1.3964844,0.8369141-1.9550781c0.5585938-0.5585938,1.2089844-0.8378906,1.9550781-0.8378906
        c0.7441406,0,1.3964844,0.2792969,1.9550781,0.8378906s0.8378906,1.2109375,0.8378906,1.9550781
        c0,2.328125,0.8134766,4.3066406,2.4433594,5.9345703c1.6279297,1.6298828,3.6074219,2.4433594,5.9345703,2.4433594
        c2.3261719,0,4.3056641-0.8134766,5.9355469-2.4433594c1.6269531-1.6279297,2.4433594-3.6064453,2.4433594-5.9345703
        c0-2.3261719-0.8164063-4.3046875-2.4433594-5.9345703c-1.6298828-1.6279297-3.609375-2.4433594-5.9355469-2.4433594
        c-3.8173828,0-7.0996094-1.3730469-9.84375-4.1191406c-2.7470703-2.7451172-4.1191406-6.0263672-4.1191406-9.8447266
        C885.0732422,700.6965942,886.4453125,697.4153442,889.1923828,694.6682739z"/>
    <polygon class="st3" points="562.4959106,843.1004028 624.9824829,843.1004028 624.9824829,968.1489868 593.7010498,999.354126 
        562.4959106,999.354126  "/>
</g>
<g id="Layer_14">
    <line class="st5" x1="156.1846924" y1="843.0487671" x2="187.4097748" y2="811.8649902"/>
    <line class="st5" x1="124.9596252" y1="843.0487671" x2="156.1846924" y2="811.8649902"/>
    <line class="st5" x1="156.1846924" y1="811.8237305" x2="187.4097748" y2="780.6399536"/>
    <line class="st5" x1="218.6348419" y1="843.069458" x2="249.8599243" y2="811.8856812"/>
    <line class="st5" x1="187.4097748" y1="843.069458" x2="218.6348419" y2="811.8856812"/>
    <line class="st5" x1="218.6348419" y1="811.8443604" x2="249.8599243" y2="780.6605835"/>
    <line class="st5" x1="187.4097748" y1="811.8443604" x2="218.6348419" y2="780.6605835"/>
    <line class="st5" x1="281.0849915" y1="843.0797729" x2="312.3100586" y2="811.8959961"/>
    <line class="st5" x1="249.8599243" y1="843.0797729" x2="281.0849915" y2="811.8959961"/>
    <line class="st5" x1="312.3100586" y1="780.6708984" x2="281.0849915" y2="811.8546753"/>
    <line class="st5" x1="249.8599243" y1="811.8546753" x2="281.0849915" y2="780.6708984"/>
    <line class="st5" x1="343.5351257" y1="843.1004028" x2="374.7602234" y2="811.916626"/>
    <line class="st5" x1="312.3100586" y1="843.1004028" x2="343.5351257" y2="811.916626"/>
    <line class="st5" x1="343.5351257" y1="811.8753662" x2="374.7602234" y2="780.6915894"/>
    <line class="st5" x1="312.3100586" y1="811.8753662" x2="343.5351257" y2="780.6915894"/>
    <line class="st5" x1="218.6348419" y1="780.6605835" x2="249.8599243" y2="749.4768066"/>
    <line class="st5" x1="187.4097748" y1="780.6605835" x2="218.6348419" y2="749.4768066"/>
    <line class="st5" x1="218.6348419" y1="749.4355469" x2="249.8599243" y2="718.25177"/>
    <line class="st5" x1="281.0849915" y1="780.6708984" x2="312.3100586" y2="749.4871216"/>
    <line class="st5" x1="249.8599243" y1="780.6708984" x2="281.0849915" y2="749.4871216"/>
    <line class="st5" x1="281.0849915" y1="749.4458618" x2="312.3100586" y2="718.262085"/>
    <line class="st5" x1="249.8599243" y1="749.4458618" x2="281.0849915" y2="718.262085"/>
    <line class="st5" x1="343.5351257" y1="780.6915894" x2="374.7602234" y2="749.5078125"/>
    <line class="st5" x1="312.3100586" y1="780.6915894" x2="343.5351257" y2="749.5078125"/>
    <line class="st5" x1="343.5351257" y1="749.4664917" x2="374.7602234" y2="718.2827148"/>
    <line class="st5" x1="312.3100586" y1="749.4664917" x2="343.5351257" y2="718.2827148"/>
    <line class="st5" x1="281.0849915" y1="718.2104492" x2="312.3100586" y2="687.0266724"/>
    <line class="st5" x1="249.8599243" y1="718.2104492" x2="281.0849915" y2="687.0266724"/>
    <line class="st5" x1="281.0849915" y1="686.9853516" x2="312.3100586" y2="655.8015747"/>
    <line class="st5" x1="343.5351257" y1="718.2310791" x2="374.7602234" y2="687.0473022"/>
    <line class="st5" x1="312.3100586" y1="718.2310791" x2="343.5351257" y2="687.0473022"/>
    <line class="st5" x1="343.5351257" y1="687.0060425" x2="374.7602234" y2="655.8222656"/>
    <line class="st5" x1="312.3100586" y1="687.0060425" x2="343.5351257" y2="655.8222656"/>
    <line class="st5" x1="343.5351257" y1="655.8222656" x2="374.7602234" y2="624.6384888"/>
    <line class="st5" x1="312.3100586" y1="655.8222656" x2="343.5351257" y2="624.6384888"/>
    <line class="st5" x1="343.5351257" y1="624.597168" x2="374.7602234" y2="593.4133911"/>
    <polyline class="st5" points="124.9236603,843.149231 94.1966705,873.8356323 94.1966705,874.75   "/>
</g>
</svg>
`;

    window['randomSoldoutText'] = function(){
        var TEXTS = [
            'RELIC RENEWED',
            'SERVING PURPOSE',
            'SIGNAL EMITTING',
            'EMBLEM EXERCISED',
            'BEACON MOBILIZED',
            'DECOY DISPATCHED',
            'SYSTEM IN PLAY',
            'UNIT EXAPTATING',
            'MASS WEIGHED',
            'RITE OBSERVED',
            'SEAL BROKEN',
            'MARK BESTOWED',
            'FORM UNLEASHED',
            'CIRCULATING',
            'LICENSE ISSUED',
            'CLEARANCE GRANTED',
            'STATE CHANGED',
            'PRESENCE KNOWN',
            'THRESHOLD CROSSED',
            'PHASE ENTERED',
            'OUTPUT LIVE',
            'PROCESS COMPLETE'
        ];
        return TEXTS[Math.floor(Math.random() * TEXTS.length)];
    }

    const CONFIG = {
        ids: {
            container: "CONTENT_CONTAINER",
            browser: "BROWSER",
            searchPanel: "SEARCH_PANEL",
            viewPanel: "VIEW_PANEL",
            categoryList: "CATEGORY_LIST",
            searchResults: "SEARCH_RESULTS",
            input: "BROWSER_SEARCH_INPUT"
        },
        vars: {
            bg: "var(--MainValue, #1a1a1a)",
            highlight: "var(--Highlight, #ff4400)",
            text: "#ffffff",
            fontMono: "'Courier New', Courier, monospace", // Fallback if main font isn't loaded
            videoPlaceholder: "https://cdn.shopify.com/videos/c/o/v/23af3340627a44fbafc1fe08162fee29.mp4" // Optimized 6.87MB video (516x914)
        }
    };

    // Safe access to global helpers if they exist, else fallbacks
    const Helpers = {
        price: (p) => (window.formatShopifyPrice && shopifyData?.cart?.currency) 
            ? window.formatShopifyPrice(p, shopifyData.cart.currency) 
            : '$' + (p / 100).toFixed(2),
        img: (src, size) => window.shopifyResize 
            ? window.shopifyResize(src, size) 
            : src,
        clickProduct: (id) => window.BUILD_PRODUCT 
            ? `BUILD_PRODUCT(${id},undefined,undefined,undefined,true)` 
            : `console.log('Clicked product ${id}')`
    };

    // --- 2. CSS STYLES ---

    const STYLES = `

        #${CONFIG.ids.browser} i{
            text-transform: lowercase !important;
        }

        /* Scope Everything to #BROWSER */
        #${CONFIG.ids.browser} {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: row;
            overflow: hidden;
            background: #000;
            font-family: HelveticaNow, sans-serif;
            box-sizing: border-box;
            position: relative;
            --panel-bg: var(--MainValue);
        }

        #${CONFIG.ids.browser} * {
            box-sizing: border-box;
        }

        /* --- LEFT PANEL (Search/Nav) --- */
        .browser-left-col {
            width: 52.1vh;
            height: calc(100% + 1px);
            position: relative;
            border-right: 1px solid var(--AntiValue);
            z-index: 10;

            contain: layout paint size;

        }

        /* Video Background */
        .browser-bg-video {
            contain: layout paint size;

            filter: opacity(0.99);

            /* Force software rendering to prevent DXGI swap chain conflicts with WebGL */
            transform: translateZ(0);
            will-change: auto;
            backface-visibility: hidden;

            filter: grayscale(1) contrast(1.5) saturate(1);
            transition: filter 0.35s cubic-bezier(0, 0.54, 0, 1);

            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            
            z-index: 0;

            object-fit: cover; /* contain; HIGHER PERFORMANCE? */
        }

        .browser-vod-wrapper{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            
            z-index: 0;

            cursor: pointer;
        }

        .browser-vod-wrapper:hover .browser-bg-video{
            filter: grayscale(0) contrast(1);
        }

        .browser-vod-wrapper svg{
            z-index: 1;
            width: calc(100% + 2px);
            position: absolute;
            bottom: -1px;
            left: -1px;
        }

        .browser-vod-wrapper:hover svg{
            
        }
        .browser-vod-wrapper:hover .st0{
            stroke: var(--Highlight) !important;
            fill: var(--AntiValue) !important;
        }
        .browser-vod-wrapper:hover .st1{
            stroke: var(--Highlight) !important;
            fill: var(--Highlight) !important;
        }
        .browser-vod-wrapper:hover .st2{
            stroke: var(--Highlight) !important;
        }
        .browser-vod-wrapper:hover .st3{
            fill: var(--MainValue) !important;
        }
        .browser-vod-wrapper:hover .st4{
            fill: var(--Highlight) !important;
        }
        .browser-vod-wrapper:hover .st5{
            stroke: var(--Highlight) !important;
            fill: var(--Highlight) !important;
        }

        .starRotator{
            -webkit-animation: rotates 3s infinite linear;
            animation: rotates 3s infinite linear;
            transform-box: fill-box;      /* use the elementâ€™s own box */
  transform-origin: center;     /* or: 0 0 for its own origin */
        }


        /* The Retractable Tray */
        #${CONFIG.ids.searchPanel} {
            position: absolute;
            top: 0px;
            left: 0;
            width: 100%;
            height: calc(5vh + 1px); /* Default collapsed height — matches .collection-header so the bottom strokes line up */
            background: var(--MainValue);
            color: var(--AntiValue)
            /* backdrop-filter: blur(10px); */
            z-index: 2;
            overflow: hidden;
            transition: height 0.4s cubic-bezier(0.16, 1, 0.3, 1);
            border-bottom: 1px solid var(--AntiValue);
            display: flex;
            flex-direction: column;
        }

        /* Hover interaction for Desktop */
        @media (orientation: landscape) {
            #${CONFIG.ids.searchPanel}:hover,
            #${CONFIG.ids.searchPanel}.is-active {
                height: 100%;
            }
            .cat-item { font-size: 2.5vh !important; }
            .cat-group-title { font-size: 1.1vh !important; }
        }

        /* Top Bar (Visible always) */
        .search-bar-row {
            height: calc(5vh + 1px);
            min-height: calc(5vh + 1px);
            display: flex;
            align-items: center;
            padding: 0 1vh;
            padding-left: 1.25vh;
            border-bottom: 1px solid transparent;
            width: 100%;
            flex-shrink: 0;
        }
        
        #${CONFIG.ids.searchPanel} .search-bar-row {
            border-bottom: 1px solid var(--AntiValue);
        } 

        .category-trigger {
            font-weight: bold;
            color: var(--MainValue);
            margin-right: 1vh;
            cursor: pointer;
            text-transform: uppercase;
            font-size: 1.5vh;
            display: flex;
            align-items: center;
            gap: 0.5vh;
        }

        .search-input-wrapper {
            flex: 1;
            position: relative;
        }

        #${CONFIG.ids.input} {
            width: 100%;
            background: transparent;
            border: none;
            color: var(--AntiValue);
            font-family: inherit;
            font-size: 2.25vh;
            text-transform: uppercase;
            outline: none;
        }
        #${CONFIG.ids.input}::placeholder { 
            color: var(--ProductBright); 
        }

        /* Tray Content (Hidden when collapsed) */
        .tray-content {
            flex: 1;
            overflow-y: auto;
            /* padding: 1vh; */
            padding-top: 0;
            opacity: 1;
            transition: opacity 0.2s;
            pointer-events: auto;
            /* pointer-events: none;  Prevent clicking when collapsed */
            padding-bottom: 1vh;
            /* No visible scrollbar: during the open/close height transition the
               content momentarily overflows and the scrollbar flashes in/out. */
            scrollbar-width: none;
            -ms-overflow-style: none;
        }
        .tray-content::-webkit-scrollbar {
            width: 0;
            height: 0;
            display: none;
        }

        /*
        #${CONFIG.ids.searchPanel}:hover .tray-content,
        #${CONFIG.ids.searchPanel}.is-active .tray-content {
            opacity: 1;
            pointer-events: auto;
        }
        */

        /* Footer links in tray (mobile only) */
        .tray-footer-section { display: none; }
        @media (orientation: portrait), (max-aspect-ratio: 1/1) {
            .tray-footer-section { display: flex; flex-direction: column; align-items: center; border-top: 1px solid var(--ProductDim); margin-top: 1vh; padding: 1vh 0; gap: 0.5vh; }
        }
        .tray-footer-row {
            display: flex;
            flex-direction: row;
            justify-content: center;
            flex-wrap: wrap;
            gap: 0;
        }
        .tray-link {
            display: inline-block;
            color: var(--AntiValue);
            text-transform: uppercase;
            font-size: 1.75vh;
            padding: 0.4vh 1vh;
            cursor: pointer;
            text-decoration: none;
        }
        .tray-link:hover {
            color: var(--MainValue) !important;
            background-color: var(--AntiValue) !important;
        }
        .tray-link.tray-discord {
            background-color: var(--Highlight);
            color: var(--LumaCond);
            border: 1px solid var(--AntiValue);
            font-weight: bold;
            margin-right: 1.25vh;
        }
        .tray-link.tray-discord:hover {
            background-color: var(--Highlight) !important;
            color: var(--LumaCond) !important;
            border-color: var(--AntiValue) !important;
        }

        /* Category List Styles */
        .cat-group-title {
            color: var(--ProductBright);
            font-size: 0.8vh;
            margin-top: 1vh;
            margin-bottom: 0.9vh;
            text-transform: uppercase;
            letter-spacing: 1px;
            padding: 0 1vh;
        }

        .cat-group-title:not(:first-child){
            margin-top: 0.8vh;
        }

        .cat-item {
            display: block;
            color: var(--AntiValue);
            padding: 0.5vh 0.125vh;
            cursor: pointer;
            text-transform: uppercase;
            font-size: 1.75vh;
            padding: 0.5vh 1vh 0.5vh 1.25vh;
            border-top: 1px solid transparent;
            border-bottom: 1px solid transparent;
            box-sizing: border-box;
        }
        .cat-item:hover { 
            color: var(--MainValue) !important; 
            background-color: var(--AntiValue) !important; 

        }
        .cat-item.active { 
            background-color: var(--Highlight); 
            color: var(--LumaCond);
            /* text-decoration: underline; */ 

            border-top: 1px solid var(--AntiValue);
            border-bottom: 1px solid var(--AntiValue);

        }

        /* Search Results in Tray */
        .tray-search-hit {
            display: flex;
            gap: 1vh;
            padding: 0;
            border-bottom: 1px dotted var(--AntiValue);
            cursor: pointer;
        }
        .tray-search-hit img { 
            width: 5vh; height: 5vh; object-fit: cover; 
        }
        .tray-search-hit div { display: flex; flex-direction: column; justify-content: center; }

        .tray-search-hit:nth-child(2){
            border-top: 1px dotted var(--AntiValue);
        }

        .searchHitSelected{
            background-color: var(--Highlight) !important;
        }
        .searchHitSelected .cat-hit-title-wrap .cat-hit-title{
            color: var(--LumaCond) !important;
        }
        .searchHitSelected .cat-hit-title-wrap .cat-hit-price{
            color: var(--LumaCond) !important;
        }

        /* --- RIGHT PANEL (View) --- */
        #${CONFIG.ids.viewPanel} {
            flex: 1;
            height: calc(100% + 1px);
            background: var(--panel-bg);
            overflow-y: auto;
            overflow-x: hidden;
            position: relative;
        }

        /* Product Grid */
        .browser-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(40vh, 1fr));
            gap: 0px;
            /* background: var(--AntiValue);  Gap color */
        }

        .collection-header {
            width: 100%;
            padding: 1vh;
            background: var(--MainValue);
            color: var(--AntiValue);
            text-transform: uppercase;
            border-bottom: 1px solid var(--AntiValue);
            position: sticky;
            top: 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            cursor: pointer;
            height: calc(5vh + 1px);
            font-size: 2.25vh;
            padding-left: 1.5vh;
            z-index: 10;
        }
        .collection-header i { transition: transform 0.3s; }
        .collection-header.collapsed i { transform: rotate(-90deg); }
        .collection-header.collapsed:not(:nth-last-child(2)) { 
            border-bottom: 0px !important;
            height: 5vh !important;
        }

        .collection-header:not(:first-child) {
            border-top: 1px solid var(--AntiValue);
        }

        /* Product Card */
        .b-product {
            background: #1a1a1a; /* Grey box */
            aspect-ratio: 1;
            position: relative;
            cursor: pointer;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            border-bottom: 1px solid var(--AntiValue);
            border-right: 1px solid var(--AntiValue);
        }
        .b-product:hover .b-p-img { 
            transform: scale(1.005); 
        }
        .b-product:hover .productIconBox{
            background: var(--Highlight) !important;
            color: var(--LumaCond) !important;
        }
        .b-product:hover .productDogear svg polygon{
            fill: var(--Highlight) !important;
        }
        
        .b-p-img-container {
            position: relative;
            width: 100%;
            height: calc(100% - 5vh);
            overflow: hidden;
        }

        .b-p-img.backshot{
            transform: scale(1.005); 
        }

        .b-p-img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.35s cubic-bezier(0, 0.54, 0, 1);
            transform: scale(1.08);
        }

        .b-p-img.overshot {
            z-index: 2;
            opacity: 0;
            transition: opacity 0.3s ease-in-out, transform 0.35s cubic-bezier(0, 0.54, 0, 1);
        }

        .b-product:hover .overshot {
            transform: scale(1.005); 
            animation: bffade 3.5s linear infinite;
        }

        @keyframes bffade {
            0% { opacity: 0; }
            10% { opacity: 0; }
            15% { opacity: 1; }
            60% { opacity: 1; }
            65% { opacity: 0; }
            100% { opacity: 0; }
        }

        .b-p-info-wrap{
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 5vh;
            max-height: 5vh;
            color: var(--MainValue);
            pointer-events: none;
            display: flex;
            justify-content: space-between;
            z-index: 5;
        }

        .b-p-info {
            position: relative;
            width: 100%;
            padding: 1vh 1.5vh;
            background: var(--AntiValue);
            color: var(--MainValue);
            pointer-events: none;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        .b-p-title { 
            font-size: 2.5vh; 
            line-height: 1;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .b-p-price { 
            font-size: 2.5vh; 
            color: var(--ProductBright); 
            white-space: nowrap;
            flex-shrink: 0;
        }

        .b-info-tag { 
            position: absolute; 
            bottom: 5vh; 
            right: 0vh; 
            background: var(--Highlight); 
            color: var(--LumaCond); 
            font-size: 2.2vh; 
            padding: 0.4vh 0.8vh 0.4vh 1.5vh; 
            height: 5vh;
            width: 100%;
            display: flex;
            align-items: center;
            font-family: 'wideFont';
            z-index: 4;
        }
        .b-sold-out{
            background: var(--MainValue) !important;
            color: var(--AntiValue) !important;
        }

        /* --- MOBILE / PORTRAIT OVERRIDES --- */
        @media (orientation: portrait) {
            #${CONFIG.ids.browser} {
                flex-direction: column;
            }

            .browser-left-col {
                width: 100%;
                height: auto;
                position: absolute;
                top: 0;
                left: 0;
                z-index: 100;
                border-right: none;
                pointer-events: none; /* Let clicks pass through when collapsed */
                contain: none !important;
            }

            #${CONFIG.ids.searchPanel} {
                height: auto; /* Allow content to dictate */
                max-height: calc(5vh + 1px); /* Collapsed state — +1px accounts for the panel's border-box top+bottom borders so the section divider doesn't hop 1px down when the tray opens */
                background: var(--MainValue);
                border-bottom: 1px solid var(--AntiValue);
                pointer-events: auto; /* Re-enable clicks on bar */
                border-top: 1px solid var(--AntiValue);
            }

            #${CONFIG.ids.searchPanel}.is-mobile-open {
                max-height: 80vh; /* Expanded state */
                box-shadow: 0 10px 20px rgba(0,0,0,0.5);
            }

            .search-bar-row {
                padding: 0;
                /* Keep the mobile bar at exactly 5vh (the +1px is desktop-only,
                   where it aligns with .collection-header) */
                height: 5vh;
                min-height: 5vh;
            }

            /* Mobile Category Selector Box */
            .mobile-cat-btn {
                width: 10vh;
                height: calc(5vh - 1px); /* Row content box is 5vh minus its 1px bottom border; matching it keeps the button's bottom flush above the divider instead of poking ~0.5px over the line (which looked like the button growing on tap) */
                background: var(--Highlight);
                color: var(--LumaCond);
                display: flex !important;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                /* border-bottom: 1px solid var(--AntiValue); */
            }
            .mobile-cat-btn i { font-size: 2.6vh; -webkit-text-stroke: 0.4px; }

            /* View Panel adapts */
            #${CONFIG.ids.viewPanel} {
                padding-top: 5vh; /* Make room for fixed header */
                width: 100%;
            }

            .browser-grid {
                grid-template-columns: 1fr;
            }
            
            /*
            .b-product {
                aspect-ratio: auto;
                height: 120px;
                flex-direction: row;
            }
            .b-p-img { width: 120px; height: 100%; }
            .b-p-info { 
                position: relative; 
                background: none; 
                display: flex; 
                flex-direction: column; 
                justify-content: center;
                padding-left: 1rem;
            }
            .b-p-title { font-size: 1rem; margin-bottom: 0.5rem; }

            */

            /* Video hidden on mobile to simplify layout or as per design */
            .browser-bg-video { 
                display: none; 
            }

            .tray-content{
                padding-bottom: 0 !important;
            }

            #viewPanelWrapper{
                overflow: hidden;
                height: 100%;
            }

            .collection-header{
                border-top: none !important;
            }

            .tray-search-hit{
                padding: 0vh;
            }
            .tray-search-hit img{
                height: 7.5vh;
                width: 7.5vh;
            }
            .cat-hit-title-wrap{
                padding-left: 1vh;
            }
            .cat-hit-title{
                color:var(--AntiValue); 
                font-size:2vh;
            }
            .cat-hit-price{
                color:var(--ProductHalfBright); 
                font-size:1.5vh;
            }

        }
        .productIconBox{
            width: 5vh;
            height: 5vh;
            background: var(--MainValue);
            color: var(--AntiValue);
            display: flex;
            justify-content: center;
            align-items: center;
            flex-shrink: 0;
            transition: background-color 0.35s cubic-bezier(0, 0.54, 0, 1), color 0.35s cubic-bezier(0, 0.54, 0, 1);
        }
        .productIconBox i{
            font-size: 3.5vh;
        }
        .b-sold-out i.b-sold-out-icon{
            font-size: 3vh;
        }
        .productIconInline{
            font-size:3.5vh; 
            /*
            position:absolute; 
            bottom:1vh; 
            right:1.25vh; 
            color:var(--MainValue);
            */
        }
        .mobile-cat-btn{
            display: none;
        }
        #viewPanelWrapper{
            position: relative;
            flex: 1;
        }
        .cat-hit-title{
            color:var(--AntiValue); 
            font-size:1.5vh;
        }
        .cat-hit-price{
            color:var(--ProductHalfBright); 
            font-size:1.25vh;
        }
        .cat-hit-title-wrap{

        }
        .productDogear{
            position: absolute;
            right: 0;
            bottom: 5vh;
            width: 5vh;
            height: 5vh;
            overflow: hidden;
        }
        .productDogear svg{
            position: absolute;
            left: -1px;
            top: -1px;
            /* subpixel fix */
            width: calc(100% + 2px);
            height: calc(100% + 2px);
        }
        .productDogear svg polygon{
            fill: var(--MainValue);
            transition: fill 0.35s cubic-bezier(0, 0.54, 0, 1);
        }
        .b-product-bottom-item{
            border-bottom: 0px !important;
        }
        .b-p-img-soldout{
            filter: grayscale(1) brightness(0.8) contrast(3);
        }
        .b-sold-out-icon{
            font-size: 3vh;
            padding-right: 0.8vh;
            position: relative;
            left: -0.3vh;

        }
    `;

    // --- 3. CLASS DEFINITION ---

    class DecoyBrowser {
        constructor() {
            this.container = document.getElementById(CONFIG.ids.container);
            this.data = window.shopifyData;
            this.state = {
                currentCategory: 'ALL', // 'ALL' or specific handle
                searchQuery: '',
                isMobileOpen: false
            };
            
            if (!this.data) {
                console.error("Shopify Data not found");
                return;
            }

            this.init();
        }

        init() {
            // Inject Styles
            const styleTag = document.createElement('style');
            styleTag.textContent = STYLES;
            document.head.appendChild(styleTag);

            // Build Structure
            this.buildStructure();

            // Cache DOM Elements
            this.dom = {
                browser: document.getElementById(CONFIG.ids.browser),
                searchPanel: document.getElementById(CONFIG.ids.searchPanel),
                viewPanel: document.getElementById(CONFIG.ids.viewPanel),
                input: document.getElementById(CONFIG.ids.input),
                catList: document.getElementById(CONFIG.ids.categoryList),
                results: document.getElementById(CONFIG.ids.searchResults),
                video: document.querySelector('.browser-bg-video')
            };

            // Background lookbook video: landing-page only, desktop only, loaded
            // once and never re-fetched (~7MB). Kicked off on idle so its download
            // never competes with the boot-critical 3D viewer, and so window.MOBILE
            // is populated by the time we check it. A deep-linked product page does
            // NOT load it; closing that product back to the grid loads it once.
            this._bgVideoLoaded = false;
            this.loadBgVideo = () => {
                if (this._bgVideoLoaded || !this.dom.video) return;
                // Never on mobile: UA flag, plus orientation/width fallbacks (the
                // element is also display:none in portrait) so a not-yet-set
                // window.MOBILE can't leak a load onto a phone.
                if (window.MOBILE === true) return;
                if (window.matchMedia && window.matchMedia('(orientation: portrait)').matches) return;
                if (window.innerWidth <= 768) return;
                if (window.PRODUCT_OPEN || location.pathname.indexOf('/products/') === 0) return; // landing only
                this._bgVideoLoaded = true;
                this.dom.video.innerHTML = '<source src="' + CONFIG.vars.videoPlaceholder + '" type="video/mp4">';
                this.dom.video.load();
            };
            const kickBgVideo = () => this.loadBgVideo();
            if ('requestIdleCallback' in window) {
                requestIdleCallback(kickBgVideo, { timeout: 6000 });
            } else {
                setTimeout(kickBgVideo, 3000);
            }
            // If we booted on a product page (deep link), the idle kick above bails;
            // load the bg video the first time the user returns to the grid.
            if (typeof window.CLOSE_PRODUCT === 'function' && !window.__bgVideoCloseHook) {
                window.__bgVideoCloseHook = true;
                const _origClose = window.CLOSE_PRODUCT;
                window.CLOSE_PRODUCT = function () {
                    const _r = _origClose.apply(this, arguments);
                    kickBgVideo();
                    return _r;
                };
            }

            // Mobile: create IntersectionObserver for overshot image loading
            // Must exist before renderViewPanel() so initial cards get observed
            if ('IntersectionObserver' in window && window.matchMedia('(orientation: portrait)').matches) {
                this._overshotObserver = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            const overshot = entry.target.querySelector('.overshot[data-src]');
                            if (overshot) {
                                overshot.src = overshot.dataset.src;
                                overshot.removeAttribute('data-src');
                            }
                            this._overshotObserver.unobserve(entry.target);
                        }
                    });
                }, { rootMargin: '200px 0px' });
            }

            // Initial Renders
            this.renderCategoryList();
            this.renderViewPanel();

            // Bind Events
            this.bindEvents();

            window["scrollable"] = document.getElementById("VIEW_PANEL");
            scrollable.addEventListener(
                "scroll",
                () => {
                    if (scrollable.scrollTop > 50 && window["ARROWDOWNCLOSED"] == false) {
                        closeArrowDown();
                    }
                },
                { passive: true }
            );

        }

        buildStructure() {
            const html = `
            <div id="${CONFIG.ids.browser}">
                <!-- Left / Top Column -->
                <div class="browser-left-col">
                    <div class="browser-vod-wrapper" onclick="BUILD_PRODUCT(10255209496891,undefined,undefined,undefined,true)">
                        <video class="browser-bg-video" id="hero-video" disablepictureinpicture autoplay loop muted playsinline webkit-playsinline x-webkit-airplay="deny" poster="https://cdn.shopify.com/s/files/1/0873/7656/0443/files/lander-poster.jpg?v=1770788821">
                            <!-- Source injected dynamically on desktop only -->
                        </video>

                        `+VOD_SVG+`

                    </div>

                    <div id="${CONFIG.ids.searchPanel}">
                        <!-- Top Bar -->
                        <div class="search-bar-row">
                            <!-- Mobile-only Colored Box -->
                            <div class="mobile-cat-btn" onclick="document.dispatchEvent(new CustomEvent('toggle-mobile-tray'))">
                                <i class="material-icons">grid_view</i>
                            </div>
                            
                            <!-- Desktop Trigger -->
                            <div class="category-trigger" style="display:none;">
                                <span>ALL</span>
                                <i class="material-icons">arrow_drop_down</i>
                            </div>

                            <!-- Search Input -->
                            <div class="search-input-wrapper">
                                <input type="text" id="${CONFIG.ids.input}" placeholder="SEARCH..." autocomplete="off">
                            </div>
                        </div>

                        <!-- Tray Content (Categories & Search Results) -->
                        <div class="tray-content">
                            <div id="${CONFIG.ids.searchResults}"></div>
                            <div id="${CONFIG.ids.categoryList}"></div>
                        </div>
                    </div>
                </div>

                <!-- Right / Main View -->
                <div id="viewPanelWrapper">
                    <div id="ARROWDOWN" class="` + (window['ARROWDOWNCLOSED']==true ? 'arrowDownClosed' : '') + `"><i class="material-icons">arrow_downward</i><div class="arrowdowntext">SCROLL DOWN</div></div>
                    <div id="${CONFIG.ids.viewPanel}">
                        <!-- Content injected here -->
                    </div>
                </div>
            </div>
            `;
            this.container.innerHTML = html;
        }

        bindEvents() {
            // Prevent keyboard from scrolling/resizing layout on all mobile browsers including Brave
            const resetScroll = () => { window.scrollTo(0, 0); document.documentElement.scrollTop = 0; document.body.scrollTop = 0; };
            this.dom.input.addEventListener('focus', () => {
                resetScroll();
                setTimeout(resetScroll, 50);
                setTimeout(resetScroll, 150);
                setTimeout(resetScroll, 300);
            });
            if (window.visualViewport) {
                window.visualViewport.addEventListener('scroll', resetScroll);
            }

            // Search Input
            this.dom.input.addEventListener('input', (e) => {
                const q = e.target.value.toLowerCase();
                this.state.searchQuery = q;
                if (q.length > 0) {
                    this.renderSearchResults(q);
                    // Force open mobile tray on type
                    this.setMobileTray(true);
                    this.dom.searchPanel.classList.add('is-active');
                } else {
                    this.dom.results.innerHTML = '';
                    this.dom.catList.style.display = 'block';
                    // Collapse sidebar when search is cleared
                    this.dom.searchPanel.classList.remove('is-active');
                    // Only collapse mobile tray on desktop (landscape mode)
                    if (window.matchMedia('(orientation: landscape)').matches) {
                        this.setMobileTray(false);
                    }
                }
            });

            // Keyboard Support for Search
            // 1A. Ctrl + F to focus search field
            document.addEventListener('keydown', (e) => {
                // Check if device is mobile (disable keyboard shortcuts on mobile)
                const isMobile = window.matchMedia('(orientation: portrait)').matches;

                if (e.ctrlKey && e.key === 'f') {
                    if (!isMobile && !window.PRODUCT_OPEN && !window.TopbarOpen) {
                        e.preventDefault();
                        this.dom.input.focus();
                        this.setMobileTray(true);
                        this.dom.searchPanel.classList.add('is-active');
                    }
                }

                // Note: Escape key behavior moved to global scope for universal accessibility

                // Product page keyboard shortcuts (disabled on mobile)
                if (!isMobile && window.PRODUCT_OPEN) {
                    // Size selection shortcuts (S, M, L, X, 2, 3, etc.)
                    const key = e.key.toUpperCase();

                    // Handle size shortcuts
                    if (['S', 'M', 'L', 'X', '2', '3', '4', '5'].includes(key)) {
                        e.preventDefault();
                        this.handleSizeShortcut(key);
                        return;
                    }

                    // + or F to toggle CLAY fullscreen
                    if (key === '+' || key === 'F') {
                        e.preventDefault();
                        const clayFullscreenBtn = document.getElementById('clay-fullscreen');
                        if (clayFullscreenBtn) {
                            clayFullscreenBtn.click();
                        }
                        return;
                    }

                    // Enter key to click buy button (only if not focused on an input)
                    if (e.key === 'Enter' && !['INPUT', 'TEXTAREA'].includes(document.activeElement.tagName)) {
                        e.preventDefault();
                        const buyButton = document.getElementById('PRODUCT_BUY_BUTTON');
                        if (buyButton) {
                            buyButton.click();
                        }
                        return;
                    }
                }
            });

            // 1B, 1C. Enter key, Up/Down arrow keys for search results and categories
            this.dom.input.addEventListener('keydown', (e) => {
                const isMobile = window.matchMedia('(orientation: portrait)').matches;
                const searchHits = this.dom.results.querySelectorAll('.tray-search-hit');

                // Mobile-only: Allow Enter key to select search result and close keyboard
                if (isMobile && e.key === 'Enter' && searchHits.length > 0) {
                    e.preventDefault();
                    const currentSelected = this.dom.results.querySelector('.searchHitSelected');
                    if (currentSelected) {
                        currentSelected.click();
                        // Blur the input to close mobile keyboard
                        this.dom.input.blur();
                    }
                    return;
                }

                // Disable all other keyboard navigation on mobile
                if (isMobile) return;

                // Desktop: Full keyboard navigation
                // If there are search results, handle navigation for search hits
                if (searchHits.length > 0) {
                    const currentSelected = this.dom.results.querySelector('.searchHitSelected');
                    let currentIndex = Array.from(searchHits).indexOf(currentSelected);

                    if (e.key === 'Enter') {
                        e.preventDefault();
                        if (currentSelected) {
                            currentSelected.click();
                        }
                    } else if (e.key === 'ArrowDown') {
                        e.preventDefault();
                        if (currentIndex < searchHits.length - 1) {
                            this.selectSearchHit(searchHits[currentIndex + 1]);
                        }
                    } else if (e.key === 'ArrowUp') {
                        e.preventDefault();
                        if (currentIndex > 0) {
                            this.selectSearchHit(searchHits[currentIndex - 1]);
                        }
                    }
                } else if (this.state.searchQuery === '') {
                    // If search is empty, handle navigation for categories
                    const categoryItems = this.dom.catList.querySelectorAll('.cat-item:not(.discord-link)');
                    if (categoryItems.length === 0) return;

                    const currentActive = this.dom.catList.querySelector('.cat-item.active');
                    let currentIndex = Array.from(categoryItems).indexOf(currentActive);

                    if (e.key === 'Enter') {
                        e.preventDefault();
                        if (currentActive) {
                            currentActive.click();
                            // Collapse the sidebar after selection
                            this.dom.searchPanel.classList.remove('is-active');
                            this.setMobileTray(false);
                        }
                    } else if (e.key === 'ArrowDown') {
                        e.preventDefault();
                        if (currentIndex < categoryItems.length - 1) {
                            categoryItems[currentIndex + 1].click();
                            categoryItems[currentIndex + 1].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
                        }
                    } else if (e.key === 'ArrowUp') {
                        e.preventDefault();
                        if (currentIndex > 0) {
                            categoryItems[currentIndex - 1].click();
                            categoryItems[currentIndex - 1].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
                        }
                    }
                }
            });

            // Mobile Toggle
            document.addEventListener('toggle-mobile-tray', () => {
                window._haptics?.trigger('light');/* HAPTICS */
                this.setMobileTray(!this.state.isMobileOpen);
            });

            // Mobile Category Box Logic (CSS handles display, JS handles click)
            const mobileBtn = document.querySelector('.mobile-cat-btn');
            if(getComputedStyle(mobileBtn).display !== 'none') {
                // Ensure desktop trigger is hidden
            }

            // Window resize handler to recalculate bottom items
            let resizeTimeout;
            window.addEventListener('resize', () => {
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(() => {
                    this.updateBottomRowItems();
                }, 150); // Debounce resize events
            });

            // Lazy-load overshot images (data-src -> src)
            // Desktop: load on first mouseenter (immediate, no wasted requests)
            // Mobile: load via IntersectionObserver so they're ready before touch-scroll reveals them
            const loadOvershot = (card) => {
                const overshot = card.querySelector('.overshot[data-src]');
                if (overshot) {
                    overshot.src = overshot.dataset.src;
                    overshot.removeAttribute('data-src');
                }
            };

            // Desktop: delegated mouseenter
            this.dom.viewPanel.addEventListener('mouseenter', (e) => {
                const card = e.target.closest('.b-product');
                if (card) loadOvershot(card);
            }, true);

            // Mobile: IntersectionObserver for overshot loading is created in constructor
            // (before renderViewPanel) so initial cards are observed on first render
        }

        // Helper to select a search hit and remove selection from others
        selectSearchHit(element) {
            const allHits = this.dom.results.querySelectorAll('.tray-search-hit');
            allHits.forEach(hit => hit.classList.remove('searchHitSelected'));
            element.classList.add('searchHitSelected');
            // Scroll into view
            element.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }

        // Handle size selection keyboard shortcuts
        handleSizeShortcut(key) {
            const variantsContainer = document.getElementById('PRODUCT_VARIANTS');
            if (!variantsContainer) return;

            // Find all product option elements
            const productOptions = variantsContainer.querySelectorAll('.product-option');

            // Map keyboard shortcuts to size labels
            const sizeMap = {
                'S': ['S', 'SMALL'],
                'M': ['M', 'MEDIUM'],
                'L': ['L', 'LARGE'],
                'X': ['XL', 'X-LARGE', 'EXTRA LARGE'],
                '2': ['2XL', 'XXL', '2X', 'XX-LARGE'],
                '3': ['3XL', 'XXXL', '3X', 'XXX-LARGE'],
                '4': ['4XL', 'XXXXL', '4X'],
                '5': ['5XL', 'XXXXXL', '5X']
            };

            const targetSizes = sizeMap[key];
            if (!targetSizes) return;

            // Try to find and click the matching product option
            for (const option of productOptions) {
                const optionText = option.textContent.trim().toUpperCase();

                // Check if option text matches any of the target sizes
                if (targetSizes.some(size => optionText === size || optionText.includes(size))) {
                    // Check if option is not disabled/unavailable
                    if (!option.classList.contains('disabled') &&
                        !option.classList.contains('unavailable') &&
                        !option.hasAttribute('disabled')) {
                        option.click();
                        return;
                    }
                }
            }
        }

        setMobileTray(isOpen) {
            this.state.isMobileOpen = isOpen;
            if (isOpen) {
                this.dom.searchPanel.classList.add('is-mobile-open');
            } else {
                this.dom.searchPanel.classList.remove('is-mobile-open');
            }
        }

        // --- RENDER LOGIC: CATEGORIES ---

        renderCategoryList() {
            const types = new Set();
            this.data.products.forEach(p => { if(p.type) types.add(p.type); });

            const collections = this.data.collections.map(c => ({
                title: c.title,
                handle: c.handle
            }));

            let html = `<div class="cat-group-title">COLLECTIONS</div>`;

            // "ALL" Option
            html += `<a class="cat-item ${this.state.currentCategory === 'ALL' ? 'active' : ''}" data-type="ALL">ALL</a>`;

            collections.forEach(c => {
                html += `<a class="cat-item ${this.state.currentCategory === c.handle ? 'active' : ''}" data-handle="${c.handle}">${c.title}</a>`;
            });

            html += `<div class="cat-group-title">CATEGORIES</div>`;
            types.forEach(t => {
                html += `<a class="cat-item ${this.state.currentCategory === t ? 'active' : ''}" data-type="${t}">${t}</a>`;
            });

            html += `
                <div class="tray-footer-section">
                    <div class="tray-footer-row">
                        <a class="tray-link" href="/policies/terms-of-service" target="_blank">TOS</a>
                        <a class="tray-link" href="/policies/privacy-policy" target="_blank">PRIVACY</a>
                        <a class="tray-link" href="/policies/refund-policy" target="_blank">REFUNDS</a>
                        <a class="tray-link" href="/policies/shipping-policy" target="_blank">SHIPPING</a>
                        <a class="tray-link" href="/pages/data-sharing-opt-out" target="_blank">COOKIES</a>
                    </div>
                    <div class="tray-footer-row">
                        <a class="tray-link tray-discord" href="https://discord.gg/awr6P3Qkrc" target="_blank">DISCORD</a>
                        <a class="tray-link" href="https://www.instagram.com/decoy.ltd" target="_blank">INSTA</a>
                        <a class="tray-link" href="https://x.com/DECOY_LTD" target="_blank">TWITTER</a>
                        <a class="tray-link" href="/policies/contact-information" target="_blank">CONTACT</a>
                    </div>
                </div>`;

            this.dom.catList.innerHTML = html;

            // Bind clicks
            this.dom.catList.querySelectorAll('.cat-item:not(.discord-link)').forEach(el => {
                el.addEventListener('click', (e) => {
                    window._haptics?.trigger('selection');/* HAPTICS */
                    const handle = e.target.dataset.handle;
                    const type = e.target.dataset.type;
                    
                    this.state.currentCategory = handle || type;
                    this.renderCategoryList(); // Re-render to update active class
                    this.renderViewPanel();
                    
                    // Close mobile tray on selection
                    this.setMobileTray(false);
                });
            });
        }

        // --- RENDER LOGIC: SEARCH ---

        renderSearchResults(query) {
            const matches = this.data.products.filter(p =>
                p.title.toLowerCase().includes(query) ||
                p.handle.toLowerCase().includes(query) ||
                (p.type && p.type.toLowerCase().includes(query))
            );

            this.dom.catList.style.display = 'none'; // Hide categories while searching

            if (matches.length === 0) {
                this.dom.results.innerHTML = `<div style="font-size:2vh; color:var(--ProductQuiteBright); padding:1.25vh;">NO RESULTS FOUND</div>`;
                return;
            }

            // Sort matches: available products first, sold-out products last
            const sortedMatches = matches.sort((a, b) => {
                if (a.available === b.available) return 0;
                return a.available ? -1 : 1;
            });

            let html = `<div class="cat-group-title">SEARCH RESULTS (${sortedMatches.length}) â¬Ž</div>`;
            sortedMatches.forEach(p => {
                var avail = p.available;
                html += `
                    <div class="tray-search-hit" onclick="${Helpers.clickProduct(p.id)}">
                        <img src="${'https:'+Helpers.img(p.featured_image, '100x100')}">
                        <div class="cat-hit-title-wrap">
                            <span class="cat-hit-title">${p.title}</span>
                            <span class="cat-hit-price">${!avail ? randomSoldoutText() : Helpers.price(p.price)}</span>
                        </div>
                    </div>
                `;
            });

            this.dom.results.innerHTML = html;

            // 1D. Auto-select first result
            const firstHit = this.dom.results.querySelector('.tray-search-hit');
            if (firstHit) {
                this.selectSearchHit(firstHit);
            }

            // Add mouseover event listeners to all search hits
            this.dom.results.querySelectorAll('.tray-search-hit').forEach(hit => {
                hit.addEventListener('mouseenter', () => {
                    this.selectSearchHit(hit);
                });

                // Add click handler to clear search and collapse drawer in portrait mode
                hit.addEventListener('click', () => {
                    if (window.matchMedia('(orientation: portrait)').matches) {
                        // Clear the search input
                        this.dom.input.value = '';
                        this.state.searchQuery = '';

                        // Clear search results and show categories again
                        this.dom.results.innerHTML = '';
                        this.dom.catList.style.display = 'block';

                        // Collapse the search panel
                        this.dom.searchPanel.classList.remove('is-active');
                        this.dom.searchPanel.classList.remove('is-mobile-open');
                        this.setMobileTray(false);
                    }
                });
            });
        }

        // --- RENDER LOGIC: VIEW PANEL ---

        renderViewPanel() {
            const container = this.dom.viewPanel;
            container.innerHTML = ''; // Clear
            this._cardIndex = 0; // Reset card counter for image loading priority

            // SCENARIO 1: VIEW ALL
            if (this.state.currentCategory === 'ALL') {
                // Iterate ordered keys if available, else standard collections
                const orderedKeys = Object.keys(this.data.collection_mappings);

                orderedKeys.forEach(key => {
                    const collection = this.data.collections.find(c => c.handle === key);
                    const pIds = this.data.collection_mappings[key];
                    if (!collection || !pIds) return;

                    // Header
                    const header = document.createElement('div');
                    header.className = 'collection-header';
                    header.innerHTML = `<span>${collection.title}</span><i class="material-icons">expand_more</i>`;

                    // Grid
                    const grid = document.createElement('div');
                    grid.className = 'browser-grid';

                    // Get products and sort: available first, sold-out last
                    const products = pIds
                        .map(id => this.data.products.find(p => p.id === Number(id)))
                        .filter(Boolean)
                        .sort((a, b) => {
                            if (a.available === b.available) return 0;
                            return a.available ? -1 : 1;
                        });

                    // Populate Grid
                    products.forEach(product => {
                        grid.appendChild(this.buildProductCard(product));
                    });

                    // Collapse Logic
                    header.addEventListener('click', () => {
                        header.classList.toggle('collapsed');
                        grid.style.display = grid.style.display === 'none' ? 'grid' : 'none';
                        // Recalculate bottom items after collapse/expand
                        setTimeout(() => this.updateBottomRowItems(), 0);
                    });

                    container.appendChild(header);
                    container.appendChild(grid);
                });

                // Calculate bottom row items after rendering
                setTimeout(() => this.updateBottomRowItems(), 0);

            } else {
                // SCENARIO 2: SPECIFIC FILTER
                let products = [];
                const isHandle = this.data.collections.find(c => c.handle === this.state.currentCategory);

                if (isHandle) {
                    // It's a collection
                    const pIds = this.data.collection_mappings[this.state.currentCategory] || [];
                    products = pIds.map(id => this.data.products.find(p => p.id === Number(id))).filter(Boolean);
                } else {
                    // It's a Type
                    products = this.data.products.filter(p => p.type === this.state.currentCategory);
                }

                // Sort products: available first, sold-out last
                products.sort((a, b) => {
                    if (a.available === b.available) return 0;
                    return a.available ? -1 : 1;
                });

                const grid = document.createElement('div');
                grid.className = 'browser-grid';
                products.forEach(p => grid.appendChild(this.buildProductCard(p)));
                container.appendChild(grid);

                // Don't apply bottom-item class when filtering
            }
        }

        // Detect and mark items on the bottom row of each grid
        updateBottomRowItems() {
            // Only apply when viewing ALL categories
            if (this.state.currentCategory !== 'ALL') {
                return;
            }

            const grids = this.dom.viewPanel.querySelectorAll('.browser-grid');

            grids.forEach(grid => {
                // Skip if grid is hidden (collapsed)
                if (grid.style.display === 'none') {
                    return;
                }

                const items = Array.from(grid.querySelectorAll('.b-product'));

                // Remove existing bottom-item classes
                items.forEach(item => item.classList.remove('b-product-bottom-item'));

                if (items.length === 0) return;

                // Get the bottom position of the last item (this represents the bottom row)
                const gridBottom = items[items.length - 1].getBoundingClientRect().bottom;

                // Find all items that are on the bottom row (within 1px tolerance for rounding)
                items.forEach(item => {
                    const itemBottom = item.getBoundingClientRect().bottom;
                    if (Math.abs(itemBottom - gridBottom) < 1) {
                        item.classList.add('b-product-bottom-item');
                    }
                });
            });
        }

        buildProductCard(product) {
            const el = document.createElement('div');
            el.className = 'b-product';
            el.setAttribute('onclick', Helpers.clickProduct(product.id));

            // Three-tier image loading strategy:
            // Card 0: fetchpriority="high" + eager (LCP candidate)
            // Cards 1-3: eager loading (above fold likely)
            // Cards 4+: lazy loading
            const idx = this._cardIndex++;
            const imgUrl = Helpers.img(product.featured_image, '1000x1000');
            const secondImage = product.images?.[1] || product.featured_image;
            const secondImgUrl = Helpers.img(secondImage, '1000x1000');
            const avail = product.available;

            let loadAttr, priorityAttr;
            if (idx === 0) {
                loadAttr = 'eager';
                priorityAttr = ' fetchpriority="high"';
            } else if (idx < 4) {
                loadAttr = 'eager';
                priorityAttr = '';
            } else {
                loadAttr = 'lazy';
                priorityAttr = '';
            }

            // Optional Metafields logic (simplified from original)
            let icon = 'info';
            let title = product.title;
            var bannertext = ['sell', 'MARKDOWN'];
            // Try to find metafields if structure matches existing code
            if(this.data.metafields) {
                const meta = this.data.metafields.find(m => m.id === product.id);
                if(meta && meta.icon) icon = meta.icon;
                if(meta && meta.shortname) title = meta.shortname;
                if(meta && meta.product_banner_text) bannertext = ['info', meta.product_banner_text]
            }

            var isMarkdown = product.compare_at_price != null && product.compare_at_price < product.price;

            // Overshot image uses data-src; loaded on first hover via delegated handler
            el.innerHTML = `
                <div class="b-p-img-container">
                    <img class="b-p-img overshot ${!avail ? 'b-p-img-soldout' : ''}" data-src="${'https:'+secondImgUrl}">
                    <img class="b-p-img ${!avail ? 'b-p-img-soldout' : ''}" loading="${loadAttr}"${priorityAttr} src="${'https:'+imgUrl}">
                </div>
                ${!avail ? '<div class="b-info-tag b-sold-out"><i class="material-icons b-sold-out-icon">block</i>' + randomSoldoutText() + '</div>' : (isMarkdown || bannertext[0] != 'sell' ? '<div class="b-info-tag"><i class="material-icons b-sold-out-icon">'+bannertext[0]+'</i>'+bannertext[1]+'</div>' : '')}
                <div class="b-p-info-wrap">
                    <div class="b-p-info">
                        <div class="b-p-title">${title}</div>
                        <div class="b-p-price">${!avail ? 'SOLD OUT' : Helpers.price(product.price)}</div>
                    </div>
                    <div class="productIconBox">
                        <i class="material-icons productIconInline">${icon}</i>
                        <div class="productDogear">
                            <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                              <polygon
                                points="0,100 100,0 100,100"
                              />
                            </svg>
                        </div>
                    </div>
                </div>
            `;
            // On mobile, observe this card so its overshot loads before touch interaction
            if (this._overshotObserver) {
                this._overshotObserver.observe(el);
            }
            return el;
        }
    }

    // --- 4. GLOBAL KEYBOARD HANDLER ---
    // Global Escape key handler (works on all pages, not just homepage)
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            // 1. Close Settings menu if open (highest priority)
            if (window.SETTINGS_MGR_OPEN) {
                if (window.SettingsManager?.close) {
                    window.SettingsManager.close();
                }
                return;
            }

            // 2. Close CLAY viewer fullscreen if active (second priority)
            if (window.clayInstance?.fullscreenState?.active) {
                const clayFullscreenBtn = document.getElementById('clay-fullscreen');
                if (clayFullscreenBtn) {
                    clayFullscreenBtn.click();
                    return;
                }
            }

            // 3. Close topbar if open
            if (window.TopbarOpen) {
                if (typeof window.closeTopbar === 'function') {
                    window.closeTopbar();
                }
                return;
            }

            // 4. Close cart if open
            if (window.cartOpen) {
                if (typeof window.toggleCart === 'function') {
                    window.toggleCart();
                }
                return;
            }

            // 5. Close product page if open
            if (window.PRODUCT_OPEN && !window.TopbarOpen && !window.cartOpen) {
                if (typeof window.CLOSE_PRODUCT === 'function') {
                    window.CLOSE_PRODUCT(true);
                }
                return;
            }
        }
    });

    // --- 5. INIT ---
    // Wait for DOM or run immediately if ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => new DecoyBrowser());
    } else {
        // Slight delay to ensure shopifyData is populated if script loads async
        setTimeout(() => new DecoyBrowser(), 50);
    }

})();